import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/video/getList',
        method: 'post',
        data: data
    })
}
export function createUpdate(data) {
    return request({
        url: '/backend/video/createUpdate',
        method: 'post',
        data: data
    })
}
export function getDetail(data) {
    return request({
        url: '/backend/video/getDetail',
        method: 'post',
        data: data
    })
}
export function del(data) {
    return request({
        url: '/backend/video/delete',
        method: 'post',
        data: data
    })
}
export function updateSort(data) {
    return request({
        url: '/backend/video/updateSort',
        method: 'post',
        data: data
    })
}

export function updateTopStatus(data) {//修改展示状态
    return request({
        url: '/backend/video/updateTopStatus',
        method: 'post',
        data: data
    })
}

export function updateStatus(data) {
    return request({
        url: '/backend/video/updateStatus',
        method: 'post',
        data: data
    })
}

export function updateRecommend(data) {
    return request({
        url: '/backend/video/updateRecommend',
        method: 'post',
        data: data
    })
}